module.exports = __webpack_public_path__ + "8402f95cc3e864832b7734cc14649bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_14-mobile.png
// module id = 120
// module chunks = 1